import reducer from './reducers';
import * as fillTemplatesActions from './actions';
import * as fillTemplatesSelectors from './selectors';

export { fillTemplatesActions, fillTemplatesSelectors };
export default reducer;